<div class="kv">
  <ion-card>
    <ion-card-header>
      <ion-card-title>KIR-import varázsló</ion-card-title>
      <ion-card-subtitle>
        A KIR-ből letöltött exportok egy helyen: tanulók, gondviselők, alkalmazottak. Előbb előnézet –
        mi új, mi változik, mi hibás –, és csak a jóváhagyás után ír a rendszer.
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="lepesek">
        <span [class.aktiv]="lepes === 1">1. Fájlok</span>
        <ion-icon name="chevron-forward-outline"></ion-icon>
        <span [class.aktiv]="lepes === 2">2. Előnézet</span>
        <ion-icon name="chevron-forward-outline"></ion-icon>
        <span [class.aktiv]="lepes === 3">3. Eredmény</span>
      </div>

      <p class="hiba" *ngIf="hiba">{{ hiba }}</p>

      <!-- ═══ 1. LÉPÉS: FÁJLOK ═══════════════════════════════════════════ -->
      <ng-container *ngIf="lepes === 1">
        <div class="utmutato">
          <b>Honnan töltsd le?</b>
          <ul>
            <li>
              <b>Tanulói személyi nyilvántartás</b> – a KIR személyi nyilvántartásából a tanulók listájának
              Excel-exportja. A rendszer az <code>Oktazon</code> és a <code>Viselt név vezetéknév</code> oszlopról
              ismeri fel, mellette az osztály- és jogviszony-oszlopokról (<code>Osztály</code>,
              <code>Jogviszony kezdete</code>…).
            </li>
            <li>
              <b>Alkalmazotti nyilvántartás</b> – a KIR-ben az <i>Alkalmazott keresése</i> menüpontban a keresés
              találatait az <i>Összes találat listába</i> gombbal tedd át a <i>Kérelemhez felvett személyek</i>
              ablakba, a lista alján az <i>Adatok exportálása</i> gomb, és a felugró ablakban mindhárom listát
              (Személyes adatok, Jogviszony adatok, Képzettségek) válaszd ki.
            </li>
            <li>
              <b>Gondviselők</b> – a KIR <i>„Szülő, törvényes képviselő”</i> sablonja, vagy a KRÉTA
              <i>„Szülők, törvényes képviselők elérhetőségei”</i> exportja. Mindkettőt felismeri.
            </li>
          </ul>
          <span class="halvany">
            A KIR táblázatainak mintasorát („Minta Géza”) és az ismételt fejlécsorokat a rendszer magától kihagyja,
            a fájlt nem kell előtte szerkeszteni. Több fájl is feltölthető egyszerre (Excel vagy CSV); a sorrend
            mindegy – előbb a tanulók, utána a gondviselők, végül az alkalmazottak íródnak.
          </span>
        </div>

        <div class="sor">
          <label class="fajlgomb">
            <input type="file" multiple accept=".xlsx,.xls,.csv" (change)="fajlValaszt($event)" />
            <ion-icon name="cloud-upload-outline"></ion-icon> Fájlok kiválasztása
          </label>
          <ion-input type="number" label="Munkatanév (osztályok)" label-placement="stacked" [(ngModel)]="ev"></ion-input>
          <ion-input type="number" min="-3" max="3" label="Évfolyam-eltolás (új tanulóknál)" label-placement="stacked"
                     [(ngModel)]="eltolas"></ion-input>
        </div>
        <p class="halvany">
          Az évfolyam-eltolás a következő tanév előkészítésekor kell: a KIR a mostani évfolyamot adja („9. 9/A”),
          +1-gyel „10. 10/A” osztályba kerül az új tanuló. Az osztályonkénti kézi hozzárendelés a
          <b>Tanuló import</b> képernyőn érhető el.
        </p>

        <table class="lista" *ngIf="fajlok.length">
          <tbody>
            <tr *ngFor="let f of fajlok; let i = index">
              <td>{{ f.name }}</td>
              <td class="sz">{{ meret(f.size) }}</td>
              <td class="sz"><ion-button fill="clear" size="small" color="danger" (click)="fajlTorol(i)">
                <ion-icon slot="icon-only" name="trash-outline"></ion-icon></ion-button></td>
            </tr>
          </tbody>
        </table>

        <ion-button (click)="elonezetKer()" [disabled]="!fajlok.length || betolt || !intezmeny">
          <ion-icon slot="start" name="eye-outline"></ion-icon>Előnézet (még nem ír)
        </ion-button>
        <ion-spinner *ngIf="betolt" name="crescent"></ion-spinner>
      </ng-container>

      <!-- ═══ 2. LÉPÉS: ELŐNÉZET ═════════════════════════════════════════ -->
      <ng-container *ngIf="lepes === 2 && elonezet">
        <p class="halvany">
          Ez még csak előnézet, az adatbázisban semmi nem változott. Az előnézet 30 percig érvényes.
          Üres cella és a fájlban nem szereplő oszlop nem töröl meglévő adatot.
        </p>

        <div class="fajl" *ngFor="let f of fajlokElonezet; trackBy: trackIndex">
          <div class="fajl-fej">
            <ion-checkbox *ngIf="f.felismerve" [(ngModel)]="kijelolt[f.index]" labelPlacement="end">
              <b>{{ f.fajlnev }}</b>
            </ion-checkbox>
            <b *ngIf="!f.felismerve">{{ f.fajlnev }}</b>
            <ion-badge [color]="f.felismerve ? 'primary' : 'danger'">{{ f.felismerve ? f.tipusNev : 'Nem ismert fájl' }}</ion-badge>
          </div>

          <!-- Nem ismert: mi hiányzik -->
          <div class="nemismert" *ngIf="!f.felismerve">
            <p class="hiba">{{ f.hiba }}</p>
            <ul *ngIf="f.jeloltek?.length">
              <li *ngFor="let j of f.jeloltek">
                Legközelebb ehhez áll: <b>{{ j.tipus }}</b> (munkalap: {{ j.lap }}) – hiányzik: {{ j.hianyzik.join(', ') }}
              </li>
            </ul>
            <p class="halvany" *ngIf="f.elsoSor?.length">A fájl első nem üres sora: {{ f.elsoSor.join(' · ') }}</p>
          </div>

          <ng-container *ngIf="f.felismerve">
            <p class="halvany">
              Munkalap: {{ f.lap }} · {{ f.olvasas?.sorDb }} adatsor (a {{ f.olvasas?.adatKezd }}. sortól)
              <span *ngIf="f.olvasas?.mintaDb"> · a KIR {{ f.olvasas.mintaDb }} mintasora kihagyva</span>
              <span *ngIf="f.olvasas?.ismeteltFejlec"> · {{ f.olvasas.ismeteltFejlec }} ismételt fejlécsor kihagyva</span>
            </p>
            <p class="figy" *ngIf="f.hianyzoAjanlott?.length">
              Ezek az oszlopok hiányoznak a fájlból (a sorok ettől még bemennek, de az adat üres marad):
              {{ f.hianyzoAjanlott.join(', ') }}
            </p>
            <p class="halvany" *ngIf="f.megjegyzes">{{ f.megjegyzes }}</p>

            <div class="chipek">
              <ion-chip [outline]="szuro[f.index] !== ''" (click)="szuro[f.index] = ''">
                Mind: {{ f.osszesito?.osszes }}
              </ion-chip>
              <ion-chip *ngFor="let a of ALLAPOTOK" [color]="a.szin" [outline]="szuro[f.index] !== a.kod"
                        (click)="szuro[f.index] = a.kod">
                {{ a.nev }}: {{ db(f, a.kod) }}
              </ion-chip>
            </div>

            <ion-checkbox *ngIf="f.osszesito?.modosulo" [(ngModel)]="modosulokIs[f.index]" labelPlacement="end">
              A módosuló sorokat is írja ({{ f.osszesito.modosulo }}) – kikapcsolva csak az új sorok kerülnek be
            </ion-checkbox>

            <table class="lista" *ngIf="sorokSzurve(f).length">
              <thead><tr><th class="sz">Sor</th><th>Azonosító</th><th>Név</th><th>Állapot</th><th>Részletek</th></tr></thead>
              <tbody>
                <tr *ngFor="let s of sorokMutat(f); trackBy: trackSor">
                  <td class="sz">{{ s.sor }}</td>
                  <td>{{ s.kulcs }}</td>
                  <td>{{ s.nev }}<div class="halvany" *ngIf="s.info">{{ s.info }}</div></td>
                  <td><ion-badge [color]="allapotSzin(s.allapot)">{{ allapotNev(s.allapot) }}</ion-badge></td>
                  <td>
                    <div class="hiba" *ngFor="let h of s.hibak">{{ h }}</div>
                    <div class="valt" *ngFor="let v of s.valtozasok">
                      <b>{{ v.mezo }}:</b> <span class="regi">{{ v.regi || '(üres)' }}</span> → <span class="uj">{{ v.uj || '(üres)' }}</span>
                    </div>
                    <div class="figy" *ngFor="let w of s.figyelmeztetesek">{{ w }}</div>
                  </td>
                </tr>
              </tbody>
            </table>
            <p class="halvany" *ngIf="!sorokSzurve(f).length">Nincs ilyen sor.</p>
            <ion-button fill="clear" size="small" *ngIf="sorokSzurve(f).length > (mutat[f.index] || 100)" (click)="tovabbiak(f)">
              További sorok ({{ sorokSzurve(f).length - (mutat[f.index] || 100) }})
            </ion-button>
          </ng-container>
        </div>

        <div class="sor">
          <ion-button fill="outline" (click)="vissza()" [disabled]="ir">
            <ion-icon slot="start" name="arrow-back-outline"></ion-icon>Vissza
          </ion-button>
          <ion-button color="success" (click)="iras()" [disabled]="ir || !irandoDb.fajl || (!irandoDb.uj && !irandoDb.modosulo)">
            <ion-icon slot="start" name="checkmark-done-outline"></ion-icon>
            Jóváhagyás és írás ({{ irandoDb.uj }} új, {{ irandoDb.modosulo }} módosuló)
          </ion-button>
          <ion-spinner *ngIf="ir" name="crescent"></ion-spinner>
        </div>
      </ng-container>

      <!-- ═══ 3. LÉPÉS: EREDMÉNY ═════════════════════════════════════════ -->
      <ng-container *ngIf="lepes === 3 && eredmeny">
        <table class="lista">
          <thead><tr><th>Fájl</th><th>Típus</th><th class="sz">Új</th><th class="sz">Módosítva</th><th class="sz">Kihagyva</th><th>Megjegyzés</th></tr></thead>
          <tbody>
            <tr *ngFor="let e of eredmeny.eredmeny">
              <td>{{ e.fajlnev }}</td>
              <td>{{ e.tipusNev }}</td>
              <td class="sz">{{ e.uj }}</td>
              <td class="sz">{{ e.modositva }}</td>
              <td class="sz">{{ e.kihagyva }}</td>
              <td>
                <div class="hiba" *ngFor="let h of e.hibak">{{ h }}</div>
                <div class="figy" *ngFor="let w of e.figyelmeztetesek">{{ w }}</div>
                <span class="halvany" *ngIf="!e.hibak?.length && !e.figyelmeztetesek?.length">rendben</span>
              </td>
            </tr>
          </tbody>
        </table>
        <p class="halvany">
          A kihagyott sorok: a változatlanok, a hibásak, és – ha kikapcsoltad – a módosulók. Az írás előtt a rendszer
          az előnézetet a pillanatnyi adatokból újraszámolta, ezért a számok kis mértékben eltérhetnek az előnézettől.
        </p>
        <ion-button (click)="ujra()">
          <ion-icon slot="start" name="refresh-outline"></ion-icon>Új import
        </ion-button>
      </ng-container>
    </ion-card-content>
  </ion-card>
</div>
